<template>
  <BoardView :title="$t('title')">
    <FormValidation @submit="create">
      <FormPrompt :prompt="prompt" />
      <Btn class="info" :isLoading="isSaving" type="submit">
        {{ $t('submit') }}
      </Btn>
    </FormValidation>
  </BoardView>
</template>

<script>
import BoardAdd from '@mixins/BoardAdd'
import FormPrompt from '@forms/FormPrompt'

export default {
  mixins: [
    BoardAdd('prompt', {
      redirectTo: 'Prompts',
    }),
  ],
  components: { FormPrompt },
}
</script>

<i18n>
{
  "en": {
    "title": "Add an prompt",
    "submit": "Save"
  }
}
</i18n>
